import { IFocusPayload } from '../../actions/focus-actions/focus-actions';

export const generateQuery = ({ payload }: { payload: IFocusPayload }) => {
  let { schoolId, focusKey } = payload;

  return `{
    Focus(schoolId: "${schoolId}", focusKey: "${focusKey}"){
      graphQlKeyVizGrouping
      graphQlKeyPopulationFilter
      graphType
      focusOptions {
        graphQlKey
        parent
        parentOrder
        children {
          graphQlKey
          child
          childOrder
        }
      }
      filterOptions {
        graphQlKey
        parent
        parentOrder
        children {
          graphQlKey
          child
          childOrder
        }
      }
      midLevelGroupingOptions {
        graphQlKey
        parent
        parentOrder
        children {
          graphQlKey
          child
          childOrder
        }
      }
      studentLevelGroupingOptions {
        graphQlKey
      }
      defaultStudentLevelGrouping {
        graphQlKey
      }
      defaultFilter {
        graphQlKey
      }
      defaultMidLevelGrouping {
        graphQlKey
      }
      midLevelColumns {
        graphQlKey
        columnName
        columnDataType
        columnOrder
        isFooterSetter
        footerLabel
        columnDataType
        headerTooltip
      }
      studentLevelColumns {
        graphQlKey
        columnName
        columnOrder
        columnDataFormat
        headerTooltip
        cellConfig
      }
    } 
  }
  `;
};

export const FOCUS_JOINS = [];
